// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"success_iconContainer__9C2py","msgContainer":"success_msgContainer__3BGJp","btnContainer":"success_btnContainer__1uIpA"};